
<!--
    Los TILES que se customizan para una dada implementacion.
-->

<div class="invisible"  id="customized-datagrip">
    <div name="logos-tile">
        <br/>
        <br/>
        <img class="logo" src="img/custom/analyte.jpg"/>
        <br/>
        <h5>Ayudamos a construir calidad.</h5>
        <p><a href="http://www.analyte.com">www.analyte.com</a></p>
        <p class="sp">
            <br/>
            Luis María Drago 1951, Of. 7, Piso 1.
            <br/>
            Parque Industrial de Almirante Brown (Burzaco)
            <br/>
            (1852) Buenos Aires, Argentina
        </p>
        <br/><br/>
    </div>
    <div name="datagrip-tile">
        <br/>
        <img class="logo" src="img/custom/treme/logo-datagrip-bg-negro.png"/>
        <p class="on-bottom">
            <b>Captura tu información en movimiento.</b><br/>
            @: <a class="tips" href="#">soporte@treme.com.ar</a><br/>
            T: <a class="tips" href="#">(54-11) 5258-0205</a><br/>
            www: treme.com.ar
        </p>
    </div>
</div>

<div class="invisible"  id="customized-lasau">
    <div name="logos-tile">
        <br/>
        <br/>
        <img class="logo" src="img/custom/analyte.jpg"/>
        <br/>
        <h5>Ayudamos a construir calidad.</h5>
        <p><a href="http://www.analyte.com">www.analyte.com</a></p>
        <p class="sp">
            <br/>
            Luis María Drago 1951, Of. 7, Piso 1.
            <br/>
            Parque Industrial de Almirante Brown (Burzaco)
            <br/>
            (1852) Buenos Aires, Argentina
        </p>
        <br/><br/>
    </div>
    <div name="workflow-states">
        <a ref="#edit-list" state="active">Borradores</a>
        <a ref="#init-list"  state="active">Para Enviar</a>
        <a ref="#review-list" state="active">Para Revisar</a>
        <a ref="#emited-list"  state="inactive"></a>
    </div>
    <div name="logos-tile">
        <br>
        <img class="left-logo" src="img/custom/lasau/logo-izquierdo-abierto-152x116.png">
        <img class="right-logo" src="img/custom/lasau/logo-derecho-120x23.png">
        <br>
        <br>
        <p class="on-bottom">
        </p>
    </div>
    <div name="datagrip-tile">
        <div class="logo">
            <img class="left-logo" src="img/custom/lasau/logo-inicio.png">
            <img class="right-logo" src="img/custom/lasau/logo-derecho-120x23.png">
        </div>
        <div class="contact-info">
            Servicio de Atención al Cliente
            <br><b>0810-810-8888</b>
            <br><a class="external" href="mailto:serviciotecnico@lasaulubes.com">serviciotecnico@lasaulubes.com</a>
        </div>
        <!--
        <img class="logo" src="img/custom/mccp-ds/mccp.png"/>
        <p class="on-bottom">
            Mobile Customer Care Platform<br/>
            @: <a class="tips" href="#">soporte@mobileccp.com</a><br/>
            T: <a class="tips" href="#">(54-11) 4233-7242</a><br/>
            www: <a class="tips" href="#">mobileccp.com</a>
        </p>
        -->
    </div>
</div>


<!--
    La pagina Main con sus Tiles
-->
<div class="page" id="main">
    <div class="action-bar dark-bg">
        <div class="logo"></div>
        <div class="contact-info">
            Servicio de Atención al Cliente
            <br/><b>0810-810-8888</b>
            <br/><a class="external" href="mailto:serviciotecnico@lasaulubes.com">serviciotecnico@lasaulubes.com</a>
        </div>
        <div id="me" class="tiled-grid">
            <div id="my-profile" class="no-tile" href="#session">
                <div class="left-side">
                    <h3>
                        <span  id="user-full-name">
                        Mario Aníbal Zito Dobeli Apellidado
                        </span>
                    </h3>
                    <p>
                        <span class="hidden">
                            Última visita: <span id="user-last-login">Ayer a 15:30 hs</span>
                        </span>
                    </p>
                    <p>
                        <a href="#session">
                            &nbsp; Sesión
                        </a>
                        &nbsp;
                        <a href="#prefs">
                            &nbsp; Preferencias
                        </a>
                        &nbsp;
                        <a class="refresh" href="#syncronize">
                            &nbsp; Actualizar
                        </a>
                    </p>
                </div>
                <a class="right-side" href="#session">
                    <img src="img/custom/lasau/foto-perfil.png" />
                </a>
            </div>
        </div>
    </div>
    <div class="content">
        <div id="home" class="container tiled-grid">

            <div id="new" class="tile">
                <h2 class="nav" href="#forms-list">
                    <i class="icon ion-plus"></i>
                    Nuevo ...</h2>
                <ul class="content-list">
                </ul>
            </div>

            <div id="pending" class="tile with-worklists">
                <h2 class="nav" href="#edit-list">
                    <i class="icon ion-compose nav" href="#edit-list"></i>
                    Pendientes</h2>
                <ul class="content-grid worklists hidden">
                </ul>
                <ul class="content-list">
                    <li class="nav" href="#edit-list"><a>Borradores </a> <em name="edit-count"></em></li>
                    <li class="nav" href="#init-list"><a>Para Enviar</a> <em name="init-count"></em></li>
                    <li class="nav" href="#review-list"><a>Para Revisar </a> <em name="review-count"></em></li>
                    <li class="nav" href="#emited-list"><a>Emitidos</a> <em name="emited-count"></em></li>
                </ul>
            </div>

            <div id="sent" class="tile">
                <h2 class="nav" href="#sent-list?days=1">
                    <i class="icon ion-social-buffer-outline nav" href="#sent-list?days=1"></i>
                    Historial
                </h2>
                <ul class="content-list">
                    <li class="nav" href="#sent-list?days=1"><a>Hoy</a></li>
                    <li class="nav" href="#sent-list?days=2"><a>Ayer</a></li>
                    <li class="nav" href="#sent-list?days=7"><a>Esta semana </a></li>
                    <li class="nav" href="#sent-list?days=1000"><a>Más ...</a></li>
                    <li class="nav" href="#search-list"> <i class="icon ion-android-search"></i> &nbsp; <a>Buscar ...</a></li>
                </ul>
            </div>

            <div id="copyright" class="tile center">
                <p class="sp center">
                    <span style="color:#111;display:inline-block;max-width:40em;">
                     Los análisis realizados en el presente test se basan exclusivamente en
                     el estado actual del lubricante presentado e informarán sobre su aptitud
                     al momento de la evaluación para el uso al cual se encuentra destinado
                     por el usuario. No juzgan sobre las cualidades del producto original
                     ni sobre su idoneidad para el uso dado por el consumidor que lo presenta.
                    </span>
                    <br/>
                    - - -
                    <b class="hidden">&copy; 2018-2019 - Todos los derechos reservados.</b>
                    <br/>Versión <b class='version'></b>
                </p>
                <p class="hidden center">
                    Motorizado por <a href="http://treme.com.ar" style="color:#008b00;">
                        TREMé
                        :: Información en movimiento
                        :: <b>treme.com.ar</b>
                    </a>
                </p>
             </div>
        </div>
    </div>
</div>


<!--
    La pagina de Login
-->
<div class="page" id="login">
        <div class="action-bar dark-bg">
        </div>
        <div class="content">
            <div class="container">

                <div id="login-form" class="section">
                    <form>
                        <div class="form-section">
                        <h2>Inicia tu sesión</h2>
                        <br/>
                        <!--
                        <p>
                           Necesitas conexión a Internet para poder verificar tu
                           usuario en TREMé. Asegúrate de disponer de una
                           conexión de datos Wifi, o de tener activado 3G en tu móvil.
                           Nos conectaremos a <b class="host-name">HOST</b>
                        </p>
                        <p>Antes de comenzar, necesitamos identificar y
                           activar tu dispositivo. <b>lo activaremos ahora mismo</b>.
                        </p>
                        <br/>
                        <br/>
                        -->
                        <ul class="form-list" >
                            <li class="TextField short">
                                <label>Tu correo electrónico</label>
                                    <input id="login-name" type="email" class="value" value="" />
                                    <p class="hint hidden" style="display:block;text-align:justify;padding:0 1em;">
                                        Ingresa el correo electrónico con el cual te registraste.
                                    </p>
                            </li>
                            <li class="TextField short">
                                <label>Tu contraseña</label>
                                    <input id="login-pass" type="password"  class="value" />
                                    <p class="hint hidden">
                                    Ingresa la contraseña con la cual te registraste en TREMé,
                                    o la que te ha asignado tu empresa.
                                    </p>
                                <p class="status-bar" id="activate-status"></p>
                            </li>
                            <li class="not-hidden">
                                <br/>
                                <p class="small center">
                                    Nos conectaremos a
                                    <span class="user-server-options">
                                        <select id="login-server" style="padding:0.5em;background:none;border:1px solid #eee;">
                                          <option value="lasau">Lasau Lubes</option>
                                          <!--
                                          <option value="dev">QA Treme.io</option>
                                            <option value="local">Local shim</option>
                                              For NOW until we release as PROD
                                              <option value="lasau_red_externa" selected="selected">Lasau Lubes</option>
                                              <option value="lasau_red_interna">Lasau red interna</option>
                                            -->
                                            <!--
                                            <option value="production">treme.com.ar</option>
                                            <option value="develop">desarrollo.treme.com.ar</option>
                                            -->
                                        </select>
                                    </span>
                                    <b class="host-name hidden">HOST</b>
                                    <b class="aside OptionsBtn hidden">más opciones</b>
                                </p>
                            </li>
                            <li class="buttons">
                                <br/>
                                <button class="big unlock LoginBtn" href="#home">
                                    Iniciar la sesión !
                                </button>
                                <br/>
                                <button class="big clear UnlockLink">
                                    <br/>
                                    <a>Desbloquear la sesión</a>
                                </button>
                                <button class="hidden big clear UnlockLink">
                                    <a>Olvidaste tu contraseña ?</a>
                                </button>
                                <br/>
                                <button class="big clear SignupLink">
                                    <a>No estás registrado ?</a>
                                </button>
                            </li>
                        </ul>

                        <ul class="hidden content-grid with-icons">
                            <li class="nav" href="#">
                                <i class="icon ion-wand"></i>
                                <h4 class="nav">No estas registrado ?</h4>
                                <p class="sp">Registrate ahora y comienza a recolectar datos. O pruebalo sin cargo.</p>
                            </li>
                            <li class="nav" href="#home">
                                <i class="icon ion-game-controller-b"></i>
                                <h4 class="nav">Solo una demo ?</h4>
                                <p class="sp">Puedes ingresar
                                con el usuario: <b>demo@treme.com.ar</b> y la contraseña: <b>demo</b>.
                                </p>
                            </li>
                            <li class="hidden">
                                <h4 class="nav unlock" href="#unlock-form">
                                    Desbloquear ahora !
                                </h4>
                                <p class="sp">
                                Si ya usaste antes este dispositivo, puedes
                                desbloquearlo ingresando la contraseña
                                con la cual iniciaste tu última sesión.</p>
                            </li>
                        </ul>
                        </div>
                    </form>
                </div> <!-- -section -->

                <div id="unlock-form" class="section">
                    <form>
                        <div class="form-section">
                        <h2>Desbloquea la aplicación</h2>
                        <p>Tu última sesión fue iniciada como <b id="last-user-name"></b>.</p>
                        <br/>
                        <ul class="form-list top-aligned">
                            <li class="TextField short">
                                <label>Tu contraseña</label>
                                    <input id="unlock-pass" type="password"  class="value"/>
                                    <br/>
                                    <p class="hint">
                                    Esta aplicación fue bloqueada al salir para asegurar
                                    la confidencialidad de tus datos.
                                    Para desbloquearla ingresa la contraseña
                                    con la cual iniciaste tu última sesión en este dispositivo.</p>
                                    <p class="hint">O puedes reiniciar la sesión
                                    como otro usuario. Recuerda que para ello se
                                    requiere conexión a Internet.
                                    </p>
                                <p id="unlock-status" class="status-bar"></p>
                            </li>
                            <li class="buttons">
                                <br/>
                                <button class="big UnlockBtn">
                                    &nbsp;Desbloquear ahora !
                                </button>
                                <button class="big clear ChangeUserLink">
                                    &nbsp; o  &nbsp;
                                    <a>Cambiar de usuario ...</a>
                                </button>
                            </li>
                        </ul>
                        </div>
                    </form>
                </div> <!-- .section -->

                <div id="signup-form" class="section">
                    <!--
                    Este es el formulario donde se registran nuevos usuarios
                    para Lasau
                    -->
                    <form>
                        <div class="form-section">
                        <h2>Registráte ahora</h2>
                        <ul class="form-list" >
                            <li class="TextField short">
                                <label>Nombre de la Empresa</label>
                                    <input id="signup-company" type="text" class="value" value="" />
                                    <p class="hint"></p>
                            </li>
                            <li class="TextField short">
                                <label>Tu(s) nombres</label>
                                    <input id="signup-names" type="text" class="value" value="" />
                                    <p class="hint"></p>
                            </li>
                            <li class="TextField short">
                                <label>Tu(s) apellido(s)</label>
                                    <input id="signup-surnames" type="text" class="value" value="" />
                                    <p class="hint"></p>
                            </li>
                            <li class="TextField short">
                                <label>Tu correo electrónico</label>
                                    <input id="signup-email" type="email" class="value" value="" />
                                    <p class="hint" style="display: block;">
                                        Este será el correo que deberás
                                        usar a partir de ahora para ingresar
                                        al sitio.
                                    </p>

                            </li>
                            <li>
                                <p class="status-bar" id="signup-status"></p>
                            </li>
                            <li class="hidden TextField short">
                                <label>Tu contraseña</label>
                                <input id="signup-pass" type="password"  class="value" value=""/>
                            </li>
                            <li class="buttons">
                                <br/>
                                <button class="big SignupBtn">
                                    Registrarme ahora !
                                </button>
                                <br/><br/>
                                <button class="big clear NoSignupLink">
                                    <a>Ahora no ! Lo haré más tarde.</a>
                                </button>
                                <br/>
                            </li>
                        </ul>
                        <ul class="hidden" id="signup-ok-msg">
                            <li><h3>Bienvenido !</h3>
                                    <br/>
                                    <p>Ya te hemos registrado e informado al personal de Servicio Técnico.</p>
                                    <br/>
                                    <p>Tu registro será verificado por ellos y cuando se apruebe
                                    el mismo enviaremos tu contraseña a este mismo correo.</p>
                                    <br/>
                            </li>
                        </ul>
                        </div>
                    </form>
                </div> <!-- -section -->


            </div> <!-- .container -->
            <hr/>
            <div class='footer copyright'>
            </div>
        </div>
</div>


<!--
    La pagina de perfil y preferencias.
-->
<div class="page" id="profile">

    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Mi Perfil</div>
            <div class="actions-set">
                <a class="action-btn home" href="#home"></a>
            </div>
            <div class="tabs">
                <a class="tab" href="#session">Mi sesión</a>
                <a class="tab" href="#prefs">Preferencias</a>
                <a class="tab" href="#password">Mis credenciales</a>
                <a class="tab" href="#debug-opts">Más info</a>
            </div>
            <br/>
        </div> <!-- .action-bar -->

    <div class="content">
       <div class="container">
        <div class="section" id="prefs">
          <h2>Mis preferencias</h2>
          <form>
            <ul class="form-list">
              <li class="OptionField options"
                  data-type="OptionField" data-editable="true" data-subtype="options" data-value="10pt" property="font_size">
                    <label>Tamaño del texto</label>
                    <p class="value">
                        <b href="#" value="10pt" style="font-size:10pt"> 10 </b>
                        <b href="#" value="11pt" style="font-size:11pt"> 11 </b>
                        <b href="#" value="12pt" style="font-size:12pt"> 12 </b>
                        <b href="#" value="14pt" style="font-size:14pt"> 14 </b>
                        <b href="#" value="16pt" style="font-size:16pt"> 16 </b>
                    </p>
              </li>
              <!-- li class="TextField short"
                  data-type="TextField" data-subtype="string" property="syncro-server-name">
                    <label>Servidor</label>
                    <input class="value" id="syncro-server-name-port" class="value" type="text" size="32" value=""/>
                    <p class="hint">Nombre y puerto del servidor de sincronización, ej: <b>treme.com.ar:8601</b></p>
              </li -->
              <li class="CheckField"
                  data-type="CheckField" data-editable="true" data-subtype="" property="syncro_inmediate" data-value="false">
                    <label>Sincronizar inmediatamente</label>
                    <p class="value">
                          <i class="false icon ion-ios7-circle-filled"></i>
                          <i class="true icon ion-checkmark-circled"></i>
                    </p>
                    <p class="hint">Sincronizar en cuanto se crea o modifica un registro</p>
              </li>
              <li class="CheckField"
                  data-type="CheckField" data-editable="true" data-subtype="" property="syncro_drafts" data-value="true">
                    <label>Sincronizar borradores</label>
                    <p class="value">
                          <i class="false icon ion-ios7-circle-filled"></i>
                          <i class="true icon ion-checkmark-circled"></i>
                    </p>
                    <p class="hint">Enviar también los borradores cuando se sincroniza.</p>
              </li>
              <li class="OptionField options"
                  data-type="OptionField" data-editable="true" data-subtype="options" data-value="" property="syncro_every">
                    <label>Sincronizar automáticamente cada</label>
                    <p class="value">
                            <b  value="0" class="selected">Nunca</b>
                            <b  value="1">1 minuto</b>
                            <b  value="2">2 minutos</b>
                            <b  value="5">5 minutos</b>
                            <b  value="10">10 minutos</b>
                            <b  value="30">30 minutos</b>
                            <b  value="60">60 minutos</b>
                    </p>
                    <p class="hint">Realiza la sincronización automaticamente en el intervalo especificado.</p>
              </li>
            </ul>
          </form>
        </div>
        <div class="section" id="password">
          <h2>Cambiar la contraseña</h2>
          <form>
            <ul class="form-list">
              <li class="TextField short"
                  data-type="TextField" data-editable="true" data-subtype="string" property="old-passw">
                  <label>Contraseña anterior</label>
                  <input class="value" type="text" id="old-passw" value=""/>
                  <p class="hint">Necesitamos conexión a Internet para poder modificar tu
                        contraseña en TREMé.Por favor, asegúrate de disponer de una
                        conexión de datos Wifi, o de tener activado 3G en tu móvil.
                  </p>
              </li>
              <li class="TextField short"
                  data-type="TextField" data-editable="true" data-subtype="string" property="new-passw">
                  <label>Nueva contraseña</label>
                  <input class="value" type="text" id="new-passw" value=""/>
              </li>
              <li>
                  <button class="big" id="change-password-btn">
                    Cambiar mi contraseña !
                  </button>
              </li>
            </ul>
         </form>
        </div>

        <div class="section" id="session">
          <h2>Mi sesión</h2>
          <form>
            <ul class="form-list">
              <li class="CheckField"
                  data-type="CheckField" data-editable="true" data-subtype="" property="remember_me" data-value="true">
                    <label>Recordar mis credenciales</label>
                    <p class="value">
                          <i class="false icon ion-ios7-circle-filled"></i>
                          <i class="true icon ion-checkmark-circled"></i>
                    </p>
                    <p>
                    Esto recordará tu contraseña y no será necesario que la ingreses
                    nuevamente la próxima vez.
                    </p>
              </li>
              <li class="footer center elevated">
                    <button class="block-app" id="lock-btn"><br/>Bloquear <br/>la aplicación</button>
                    &nbsp;<!--p class="sp">&nbsp;</p-->
                    <button class="change-user" id="change-user-btn"><br/>Cambiar <br/>de usuario</button>
                    &nbsp;<!--p class="sp">&nbsp;</p-->
                    <button class="close-app" id="exit-btn"><br/>Cerrar <br/>ahora !</button>
              </li>
            </ul>
          </form>
        </div>
        <div class="section" id="debug-opts">
          <h2>Información del dispositivo</h2>
          <br/>
          <form>
            <ul>
              <li>
                <div id="debug-info"></div>
                <!--
                 <a class="" href="#" id="show-local-storage">Ver todo</a> |
                 <a class="" href="#" id="dump-local-storage">Descargar</a>
                -->
              </li>
              <li>
                  <p>
                    <button class="big" id="clean-up-btn">Limpiar todos los datos</button>
                  </p>
                  <p class="hint">Esto borrará completamente TODOS los datos guardados en este dispostivo,
                  incluidos los que aún no han sido enviados a nuestro servidor.</p>
                  <p class="hint">Le sugerimos <a href="#syncronize">Sincronizar ahora !</a> y
                  luego continuar con esta opción.
                  </p>
              </li>
              <li>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </div>
</div>


<!--
    Muestra: la Lista de formularios que se pueden crear
-->
<div class="page" id="newfs">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Nuevo</div>
            <div class="actions-set">
                <a class="action-btn home" href="#home" title="Atras"></a>
                <b class="position hidden" style="color: #aaa;">?</b>
            </div>
            <h4>Agregar un nuevo registro ...</h4>
            <br/>
    </div>
    <div class="content">
        <div class="sidebar"> </div>
        <div class="container">
               <div class="section" id="forms-list" title="">
                    <div class="list-content">
                        <ul class="content-grid with-icons">
                        </ul>
                        <div class="filler">
                        </div>
                    </div>
                    <div class="footer center">
                        <br/>
                   </div>
               </div>
        </div>
    </div>
</div>


<!--
    Muestra: los registros PENDIENTES y sus formularios
-->
<div class="page" id="pendings-list-page">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Pendientes</div>
            <div class="actions-set">
                <a class="action-btn home" href="#home"></a>
                <a class="action-btn labels PrintLabelsBtn" href="#"></a>
                <a class="action-btn down" href="#"></a>
            </div>
            <div class="tabs">
                <a class="tab" href="#edit-list">Borradores</a>
                <a class="tab  selected" href="#init-list">Completar</a>
                <a class="tab" href="#review-list">Revisar</a>
                <a class="tab" href="#emited-list">Emitidos</a>
            </div>
            <br/>
    </div>
    <div class="content">
        <div class="sidebar"> </div>
        <div class="container">
               <div class="section" id="init-list" title="">
                    <div class="list-content"></div>
               </div>
               <div class="section" id="edit-list" title="">
                    <div class="list-content"></div>
               </div>
               <div class="section" id="emited-list" title="">
                    <div class="list-content"></div>
               </div>
               <div class="section" id="review-list" title="">
                    <div class="list-content"></div>
               </div>
               <div class="section" id="completed-list" title="">
                    <div class="list-content"></div>
               </div>
               <div class="section" id="reviewed-list" title="">
                    <h2 class="-hidden">Revisados y listos para enviar</h2>
                    <div class="list-content"></div>
               </div>
               <div class="section" id="printed-list" title="">
                    <h2 class="-hidden">Para imprimir</h2>
                    <ul></ul>
               </div>
        </div>
    </div>
    <div class="footer center elevated">
        <button class="send SendBtn"><br/>Enviar todos</button>
        &nbsp;
        <button class="accept SendBtn" name="accepted"><br/>Aprobar todos</button>
        &nbsp;
        <button class="reject SendBtn" name="rejected"><br/>Rechazar todos</button>
        &nbsp; &nbsp;
        <button class="delete RemoveBtn"><br/> Eliminar todos</button>
    </div>
    <div class="filler"></div>
</div>


<div class="page" id="new-record-form">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Nuevo</div>
            <div class="actions-set">
                <a class="action-btn back CancelBtn" href="#"></a>
                <a class="action-btn down" href="#"></a>
            </div>
            <h4>Ingrese los datos de este nuevo registro ...</h4>
            <br/>
    </div>
    <div class="content">
            <div class="container">
                <div class="section" id="new-record">
                  el formulario va aqui ...
                </div>
            </div>
    </div>
    <div class="footer center elevated">
        <button class="save SaveBtn"><br/>Guardar como<br/>Borrador</button>
        <button class="accept SendBtn" name="created"><br/>Guardar como<br/><b>Tomada</b></button>
        <button class="send SendBtn" name="completed"><br/>Guardar como<br/><b>Enviada</b></button>
    </div>
    <div class="filler"></div>
</div>

<div class="page" id="edit-record-form">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Editando ...</div>
            <div class="actions-set">
                <a class="action-btn back CancelBtn" href="#"></a>
                <a class="action-btn down" href="#"></a>
            </div>
            <h4>Puede modificar los datos de este registro ...</h4>
            <br/>
    </div>
    <div class="content">
            <div class="container">
                <div class="section" id="edit-record">
                  el formulario va aqui ...
                </div>
                <div class="section" id="init-record">
                  el formulario va aqui ...
                </div>
            </div>
    </div>
    <div class="footer center elevated">
        <button class="save SaveBtn"><br/>Guardar como<br/>Borrador</button>
        <button class="send SendBtn" name="completed"><br/>Guardar como<br/><b>Enviada</b></button>
        &nbsp; &nbsp; &nbsp;
        <button class="delete RemoveBtn"><br/>Eliminar <br/>este registro</button>
    </div>
    <div class="filler"></div>
</div>

<div class="page" id="review-record-form">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Revisando ...</div>
            <div class="actions-set">
                <a class="action-btn back CancelBtn" href="#"></a>
                <a class="action-btn down" href="#"></a>
            </div>
            <h4>Revisar los datos de este registro ...</h4>
            <br/>
    </div>
    <div class="content">
            <div class="container">
                <div class="section" id="review-record">
                el formulario va aqui ...
                </div>
            </div>
    </div>
    <div class="footer center elevated">
        <button class="save SaveBtn"><br/>Guardar como<br/>Borrador</button>
        <button class="accept SendBtn" name="accepted"><br/>Aprobar<br/>y Salir</button>
        <button class="reject SendBtn" name="rejected"><br/>Rechazar<br/>y Salir</button>
    </div>
    <div class="filler"></div>
</div>

<div class="page" id="emited-record-form">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Emitido</div>
            <div class="actions-set">
               <a class="action-btn back CancelBtn" href="#"></a>
               <a class="action-btn down" href="#"></a>
            </div>
            <h4>El registro ya emitido ...</h4>
            <br/>
    </div>
    <div class="content">
            <div class="container">
                <div class="section" id="emited-record">
                  el formulario va aqui ...
                </div>
            </div>
    </div>
    <div class="footer center elevated">
        <button class="send SendBtn"><br/>Enviar registro <br/>y Salir</button>
        <p class="status">
            <span lang="es-AR">Este registro ya fue Completado. Será enviado al sincronizar.</span>
        </p>
    </div>
    <div class="filler"></div>
</div>


<!--
    Muestra: Lista de registros ya enviados y preview de los mismos
-->
<div class="page" id="sent-all">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Historial</div>
            <div class="actions-set">
                <a class="action-btn home" href="#home"></a>
                <span class="hidden action-input">
                    <input class="SearchPhrase" type="text" value="" placeholder="buscar ..." size="10"/>
                    <a class="action-btn search SearchBtn" href="#"></a>
                </span>
                <!--
                <a class="action-btn download DownloadPopupBtn hidden" href="#"></a>
                &nbsp;&nbsp;
                -->
                <a class="action-btn search SearchPopupBtn" href="#"></a>
                <a class="action-btn filter FiltersPopupBtn" href="#"></a>
                <a class="action-btn download DownloadPopupBtn" href="#"></a>
            </div>
            <div class="tabs">
                <a class="tab" href="#sent-list?days=1">Hoy</a>
                <a class="tab" href="#sent-list?days=2">Ayer</a>
                <a class="tab" href="#sent-list?days=7">Esta semana</a>
                <a class="tab" href="#sent-list?days=1000">Más ...</a>
                <a class="tab" href="#search-list">Búsquedas ...</a>
            </div>
            <br/>
    </div>
    <div class="content">
        <div class="sidebar"> </div>
        <div class="container">
               <div class="section" id="sent-list" title="Enviados">
                    <div class="list-content"></div>
               </div>
               <div class="section" id="search-list" title="Buscados">
                    <div class="list-content"></div>
               </div>
        </div>
    </div>
    <div class="filler"></div>
</div>

<div class="page" id="sent-record-view" style="height:98%;">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Buscando ...</div>
            <div class="actions-set">
                <a class="action-btn back" href="#back"></a>
                <a class="action-btn download hidden" href="#"></a>
                <a class="action-btn printer PrintPreviewBtn" href="#"></a>
            </div>
            <h4>Titulo del registro</h4>
            <br/>
    </div>
    <div class="content">
            <div class="container">
                <div class="section" id="view-record">
                  los datos del registro van aqui ...
                </div>
            </div>
    </div>
    <hr/>
    <div class="copyright center">
    </div>
    <div class="filler"></div>
</div>


<!--
    Muestra Info adicional: las listas disponibles y su contenido detallado
-->
<div class="page" id="info-lists-page">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Info</div>
            <div class="actions-set">
                <a class="action-btn home" href="#home" title="Atras"></a>
            </div>
            <h4>Información adicional disponible en las siguientes listas ...</h4>
            <br/>
    </div>
    <div class="content">
        <div class="container">
               <div class="section" id="info-lists" title="Información">
                    <div class="list-content"></div>

                    <!-- necessary Hidden ItemField -->
                    <span class="ItemField hidden"
                       data-editable="false"
                       data-type="ItemField"
                       data-source-list=""
                       data-filter="-1"
                       data-required="false"
                       data-value=""
                       href="#" property=""></span>
               </div>
        </div>
    </div>
</div>

<div class="page" id="info-items-page">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Info</div>
            <div class="actions-set">
                <a class="action-btn back" href="#info-lists" title="Atras"></a>
            </div>
            <h4>Elije un item de esta lista para ver sus detalles ...</h4>
            <br/>
    </div>
    <div class="content">
        <div class="container">
               <div class="scroller" id="info-items" title="La lista">
                    <ul class="list-content"></ul>
                </div>
        </div>
    </div>
</div>

<div class="page" id="info-details-page">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Detalle de ...</div>
            <div class="actions-set">
                <a class="action-btn back" href="#back" title="Atras"></a>
            </div>
            <h4>El item elegido bien detalladito ...</h4>
            <br/>
    </div>
    <div class="content">
        <div class="container">
               <div class="section" id="info-details" title="Información">
                    <div class="list-content">
                    </div>
               </div>
        </div>
    </div>
</div>


<!--
    Las listas de trabajo y sus items
-->
<div class="page" id="work-items-page">
    <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Info</div>
            <div class="actions-set">
                <a class="action-btn home" href="#home" title="Atras"></a>
            </div>
            <h4>Elije un item de esta lista para abrir su formulario ...</h4>
            <br/>
    </div>
    <div class="content">
        <div class="container">
               <div class="scroller" id="work-items" title="La lista">
                    <ul class="list-content"></ul>
                </div>
        </div>
    </div>
</div>


<!--
    La pagina de sincronizacion ...
-->
<div id="syncros" class="page">
        <div class="action-bar dark-bg">
            <div class="logo"></div>
            <div class="title">Sincronizando ...</div>
            <div class="actions-set">
               <a class="action-btn home" href="#home"></a>
            </div>
            <h4 id="syncro-status">Estamos sincronizando ahora ...</h4>
            <br/>
        </div>
        <div class="content">
            <div class="container">
                <div class="section" id="syncronize">
                    <div class="list-content">
                        <ul class="">
                            <li id="syncro-log"></li>
                        </ul>
                        <p>
                            <!-- button class="CancelBtn" id="syncro-done-btn"> Sincronizacion finalizada !</button -->
                            <br/>
                        </p>
                    </div>
                </div>
                <div id="debug-syncro"></div>
            </div>
        </div>
</div>


<!--
    Temp area (hidden) needed for some rendering tasks
-->
<div id="temp" class="hidden"></div>


<!--
    Controles que usan dialogos modales
-->
<div id="number-pad" class="NumericKeyboard Pad" style="width:340px;">
    <input class="hidden" type="text" style=""/>
    <div class="pointer-top">
      <i class="icon ion-arrow-up-b"></i>
    </div>
    <table border="0">
        <tr>
          <td class="num-btn" data-value="7"> 7 </td>
          <td class="num-btn" data-value="8"> 8 </td>
          <td class="num-btn" data-value="9"> 9 </td>
          <td class="op-btn"  name="alt-2" data-value="dash"></td>
          <!-- td class="op-btn" data-value="clrall">&#8602;</td -->
        </tr>
        <tr>
          <td class="num-btn" data-value="4"> 4 </td>
          <td class="num-btn" data-value="5"> 5 </td>
          <td class="num-btn" data-value="6"> 6 </td>
          <td class="op-btn" data-value="clr" style="font-weight:bold">&#8701;</td>
        </tr>
        <tr>
          <td class="num-btn" data-value="1"> 1 </td>
          <td class="num-btn" data-value="2"> 2 </td>
          <td class="num-btn" data-value="3"> 3 </td>
          <td class="op-btn" data-value="cancel" style="font-size:0.8em">Esc</td>
        </tr>
        <tr>
          <td class="num-btn" colspan="2" data-value="0">0</td>
          <td class="op-btn"  name="alt-1" data-value="coma"></td>
          <td class="op-btn" data-value="ok">&#8629;</td>
        </tr>
    </table>
</div>

<div id="calendar-pad" class="CalendarPad Pad">
  <div id="_Calendar_target hidden" class="value"></div>
  <div class="pointer-top">
      <i class="icon ion-arrow-up-b"></i>
  </div>
  <div id="_Calendar-div"></div>
</div>

<div id="options-pad" class="OptionsPad Pad" style="min-width: 284px;">
  <div id="hidden" class="value"></div>
  <div class="pointer-top">
      <i class="icon ion-arrow-up-b"></i>
  </div>
  <div class="options-list"></div>
</div>

<div id="list-pad" class="ListPad Pad">
    <div class="action-bar dark-bg">
        <div class="actions-set">
            <a class="action-btn back" href="#"></a>
            <h3>Elegir de la lista ...</h3>
            <input type="text" class="search" value="" placeholder="buscar ..." size="10"/>
        </div>
    </div>
    <div class="content">
        <div class="container">
                <div class="scroller">
                    <ul class="content-list items">
                        <!-- start of replaceable-content -->
                        <!-- end of replaceable-conten -->
                    </ul>
                    <hr/>
                    <div class="append-item-dlg hidden">
                        <h4 class="AppendItemBtn">
                            <!--
                            -->
                            <a href="#" class="row-action-btn add"></a>
                            &nbsp;
                            No esta en la lista ?
                            &nbsp;
                            <a href="#">
                                Agrégalo ahora !
                            </a>
                        </h4>
                        <ul class="form-list item-content-dlg">
                            <li class="TextField long">
                                <label>Ingresa una descripción para el nuevo ítem</label>
                                <input class="value" type="text" value="">
                                <p>
                                    El código para el mismo será creado automáticamente.
                                    <b class="new-item-code"></b>.
                                </p>
                            </li>
                            <li>
                                <button class="confirm-btn ConfirmBtn"> Agregar ahora </button>
                                &nbsp; o bien &nbsp;
                                <a href="#" class="CancelBtn"> Cancelar </a>
                            </li>
                        </ul>
                    </div>
                    <!-- FIX: se agrega para que se vea siempre el ultimo item,
                         o puede quedar tapado -->
                    <p style='height:20em;'>&nbsp;</p>
                </div>
        </div>
    </div>
</div>

<!--
    Filtros popup
-->
<div id="filters-pad" class="ActionbarPad Pad">
    <input class="hidden" type="text" style=""/>
    <div class="pointer-top">
      <img src="img/pointer-up.png" style="width:24px;margin-top:9px;margin-bottom:-5px;">
    </div>
    <form>
            <label for="order_by">Orden</label>
            <select name="order_by" id="order_by">
                <!-- debe estar primero la opcion default -->
                <option value="fecha_desc" selected="true">Fecha descendente</option>
                <option value="fecha_asc">Fecha ascendente</option>
            </select>
            <hr />
            <label for="has_text">Contiene</label>
            <input type="text" name="has_text" id="has_text" />
            <hr />
             <label for="ver">Desde</label>
             <select name="days" id="days">
                 <option value="1">Hoy</option>
                 <option value="2">Ayer</option>
                 <option value="7">Esta semana</option>
                 <option value="30">Este mes</option>
                 <option value="10000">Todos</option>
                 <option value="-2">Elegir rango</option>
             </select>
            <hr />
            <div class="no-border hidden" id="date-range">
                 <label for="ver">Desde</label>
                    <select name="date_from_dd" id="date_from_dd">
                    </select>
                    <select name="date_from_mm" id="date_from_mm">
                    </select>
                    <select name="date_from_yyyy" id="date_from_yyyy">
                    </select>
                <hr />
                 <label for="date_to">Hasta</label>
                    <select name="date_to_dd" id="date_to_dd">
                    </select>
                    <select name="date_to_mm" id="date_to_mm">
                    </select>
                    <select name="date_to_yyyy" id="date_to_yyyy">
                    </select>
                <hr />
            </div>

            <label for="who">Qui&eacute;n</label>
            <select name="who" id="who">
                <option value="-1">Todos</option>
            </select>
            <hr />
            <label for="type">Tipo</label>
            <select name="tipo" id="tipo">
                <option value="-1">Todos</option>
            </select>
            <hr />
            <label for="state">Estado</label>
            <select name="state" id="state" value="-1">
                <option value="-1">Todos</option>
                <option value="E">En edici&oacute;n</option>
                <option value="R">En revisi&oacute;n</option>
                <option value="C">Creado</option>
                <option value="AP">Aprobado</option>
                <option value="RX">Rechazado</option>
                <option value="Z">Archivado</option>
                <option value="X">Eliminado</option>
            </select>
            <hr />
            <input type="hidden" name="dias" id="dias" value="1" />
            <p class="right">
                <button class="accept" type="button"></button>
                <button class="cancel" type="button"></button>
                &nbsp;
            </p>
    </form>
</div>

<!--
    Download popup
-->
<div id="download-pad" class="ActionbarPad Pad">
    <input class="hidden" type="text" style=""/>
    <div class="pointer-top">
      <img src="img/pointer-up.png" style="width:24px;margin-top:9px;margin-bottom:-5px;">
    </div>
    <form>
            <div></div>
            <hr/>
            <p class="right">
                <button class="accept" type="button"><i class="icon ion-checkmark-round"></i></button>
                <button class="cancel" type="button"><i class="icon ion-close"></i></button>
                &nbsp;
            </p>
    </form>
</div>

<!-- DIV oculto usado para imprimir las eqtieuetas -->
<div style="display:none">
    <div id="etiqueta" class="etiqueta"></div>
</div>

<div id="labels-print-area" class="no-hidden">
</div>

<!--
<div id="blocker" class="page" style="background-color: transparent;">
    <div style="z-index:4;opacity:1.0;padding:1.5em;padding-left:30%;border-top:2px solid #ccc;border-bottom:1px solid black; background-color: #f1f1f1;opacity:1.0;text-align:left;left:0%;width:100%;top:151px;position:relative;">
    <h2>Un momento por favor ...</h2>
    <p class="message"></p>
    </div>
</div>
-->

<!--
<div class="page" id="view-info">
    <div class="action-bar">
            <div class="logo"></div>
            <div class="title"></div>
            <div class="actions-set">
               <a class="action-btn back BackBtn" href="#info"></a>
            </div>
    </div>
    <input id="info-search-input" type="search" placeholder="buscar ..."/>
    <div class="content">
            <div class="sidebar">
                <div class="pane">
                    <a class="tab selected" href="#edit-record">
                        <img src="img/extras/edit.png"/><span>Registro</span></a>
                </div>
                <ul></ul>
            </div>
            <div class="container">
                <div class="scroller"></div>
            </div>
    </div>
</div>
-->
